<template>
  <div class="tPassMsg mb-5">
    <div :class="['foobar', alertColor]">
      <div class="alert-icon">
        <i :class="['fas', messageIcon]" aria-hidden="true"></i>
      </div>
      <h6 class="modal-alert-title">{{ title }}</h6>
      <div class="modal-alert-message" v-html="msg">
        <!-- {{ msg }} -->
      </div>
      <div v-if="isShowSubMsg" class="modal-alert-message">
        <h4>{{ subMsg }}</h4>
      </div>
      <div v-if="isShowBtn" class="btn-bg" style="text-align: center">
        <b-button :variant="btnColor" class="mt-2" @click="clickBtn()">{{ btnName }}</b-button>
      </div>
    </div>
    <!-- <div v-if="isShowBtn" class="btn-bg" style="text-align: center">
      <b-button :variant="btnColor" class="mt-2" @click="clickBtn()">{{ btnName }}</b-button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'TPassMsg',

  props:{
    TPassdetailData: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      messageIcon: '',
      alertColor: '',
      title: '',
      msg: '',
      subMsg: '',
      isShowSubMsg: false,
      btnName: '',
      btnColor: 'blue',
      isShowBtn: false,
      apiLoading: false,
    };
  },
  methods: {
    changeMsgIcon(type = 'info', message, subMessage, title, options) {
      console.log('type-', type);
      console.log(' message, subMessage, title, options', message, subMessage, title, options);
      switch (type) {
        case 'success':
          this.messageIcon = 'fa-check';
          break;
        case 'warning':
          this.messageIcon = 'fa-exclamation';
          break;
        case 'error':
          this.messageIcon = 'fa-times';
          break;
        case 'info':
          this.messageIcon = 'fa-info';
          break;
        default:
          this.messageIcon = 'fa-info';
          break;
      }
      this.alertColor = `modal-alert-white-${type}`;
      this.msg = message;
      this.subMsg = subMessage;
      if (subMessage !== '') {
        this.isShowSubMsg = true;
      } else {
        this.isShowSubMsg = false;
      }
      this.title = title;
      if (options && options.isShowBtn === true) {
        this.btnName = options.btnName;
        this.isShowBtn = options.isShowBtn;
        // this.btnColor = `${type}-2`;
      }
    },
    clickBtn() {
      console.log('觸發');
      this.$emit('openTPassDetailContent', this.TPassdetailData, 'msgGoBack');
    },
  },
};
</script>
